import { VueController } from '../util/vue_controller'

// Connects to data-controller="frozen-table"
export default class extends VueController {
  static vueComponent = 'frozen-table'
}
